// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"2b8a2572","442":"c241a836","819":"def13e8d","846":"233cd770"}[chunkId] + ".chunk.css";
};